module.exports = __webpack_public_path__ + "fonts/CrystalItalic-R6A.ed62720.ttf";